<template>
  <component
    :is="pageLayoutComponent"
    title="Shrnutí publika"
    :next="nextRoute"
    :prev="prevRoute"
  >
    <ReachDialBox :store-namespace="storeNamespace" class="mb-8" />

    <ui-section title="Základní cílení" class="mb-8">
      <template #actions>
        <v-btn small text @click="$router.push(targetingBasicsRoute)">
          <img class="mr-2" :src="require('@/assets/ico-edit.svg')" alt="" />
          Změnit
        </v-btn>
      </template>

      <ui-box>
        <v-row>
          <v-col cols="12" md="6">
            <ui-box-label>
              Pohlaví
            </ui-box-label>
            <p>{{ displayGender }}</p>
          </v-col>
          <v-col cols="12" md="6">
            <ui-box-label>
              Věk
            </ui-box-label>
            <p>{{ displayAgeRange }}</p>
          </v-col>
          <v-col cols="12" md="12">
            <ui-box-label>
              Zahrnutá místa
            </ui-box-label>
            <v-row class="my-n2">
              <v-col cols="12" md="6">
                <p>{{ displayGeoLocationType }}</p>
              </v-col>
              <v-col cols="12" md="6">
                <p>{{ displayGeoLocations }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <ui-box-label>
              Vyloučená místa
            </ui-box-label>
            <p>{{ displayExcludedGeoLocations }}</p>
          </v-col>
        </v-row>
      </ui-box>
    </ui-section>

    <ui-section title="Detailní zacílení" class="mb-8">
      <template #actions>
        <v-btn small text @click="$router.push(targetingInterestsRoute)">
          <img class="mr-2" :src="require('@/assets/ico-edit.svg')" alt="" />
          Změnit
        </v-btn>
      </template>

      <ui-box>
        <v-row>
          <v-col cols="12" md="6">
            <ui-audience-group-diagram
              class="d-block mx-auto my-12"
              :n="interestsGroups.length"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col
                cols="6"
                lg="4"
                v-for="(interestGroup, i) in interestsGroups"
                :key="interestGroup.id"
              >
                <ui-box-label class="mb-2">
                  {{ groupTitleByIndex(i) }}
                </ui-box-label>

                <div
                  class="py-2"
                  v-for="interest in interestGroup.items"
                  :key="interest.id"
                >
                  {{ interest.name }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </ui-box>
    </ui-section>

    <ui-section title="Vyloučené zacílení" class="mb-8">
      <template #actions>
        <v-btn
          small
          text
          @click="$router.push(targetingExcludedInterestsRoute)"
        >
          <img class="mr-2" :src="require('@/assets/ico-edit.svg')" alt="" />
          Změnit
        </v-btn>
      </template>

      <ui-box>
        <v-row>
          <v-col cols="12" md="6">
            <icon-audience-excluded-group
              class="d-block mx-auto my-12"
              :n="interestsGroups.length"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <ui-box-label class="mb-2">
                  Vyloučená skupina
                </ui-box-label>

                <div
                  class="py-2"
                  v-for="interest in excludedInterests"
                  :key="interest.id"
                >
                  {{ interest.name }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </ui-box>
    </ui-section>

    <save-audience-dialog
      v-model="audienceName"
      :opened.sync="saveAudienceDialog"
      @confirm="onSaveAudienceClick()"
    ></save-audience-dialog>

    <template #navigation-right-prepend>
      <v-btn
        color="white"
        class="c-btn mx-2"
        min-width="186"
        :loading="loading"
        @click="onSaveAudienceClick(true)"
        v-if="storeNamespace !== 'ads'"
      >
        Uložit publikum
      </v-btn>
    </template>
  </component>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

// import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import ReachDialBox from "@/components/ui/targeting/ReachDialBox.vue"
import IconAudienceExcludedGroup from "@/components/icon/audience/ExcludedGroup.vue"
import SaveAudienceDialog from "@/components/ui/modals/SaveAudienceDialog"

import AudiencesAPI from "@/api/audiences"
import Toastification from "../../../../components/ui/Toastification"

export default {
  name: "TargetingSummary",
  components: {
    // PageLayout,
    ReachDialBox,
    IconAudienceExcludedGroup,
    SaveAudienceDialog,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    targetingBasicsRoute: {
      type: String,
      default: null,
    },
    targetingInterestsRoute: {
      type: String,
      default: null,
    },
    targetingExcludedInterestsRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      saveAudienceDialog: false,
      publish: false,
      loading: false,
    }
  },
  computed: {
    ...sync("app", ["videoTutorial"]),
    ...get("enumerations", [
      "findTargetingGenderType",
      "findTargetingGeoLocationType",
    ]),
    displayAgeRange() {
      return `${this.ageFrom} - ${this.ageTo} let`
    },
    displayGender() {
      const genderType = this.findTargetingGenderType(this.genders)

      return genderType ? genderType.name : ""
    },
    displayGeoLocationType() {
      const geoLocationType = this.findTargetingGeoLocationType(
        this.geoLocationsTypes
      )

      return geoLocationType ? geoLocationType.name : ""
    },
    displayGeoLocations() {
      const values = this.geoLocations.map(i =>
        i.fullName ? i.fullName : i.name
      )

      return values.join(" | ")
    },
    displayExcludedGeoLocations() {
      const values = this.excludedGeoLocations.map(i =>
        i.fullName ? i.fullName : i.name
      )

      return values.join(" | ")
    },
    pageLayoutComponent() {
      return () =>
        import(`@/components/page/${this.storeNamespace}/edit/PageLayout.vue`)
    },
  },
  methods: {
    groupTitleByIndex(index) {
      switch (index) {
        case 0:
          return "Základní skupina"
        case 1:
          return "Druhá skupina"
        case 2:
          return "Třetí skupina"
        default:
          return "Další skupina"
      }
    },
    onSaveAudienceClick(publish = false) {
      if (!this.publish && publish) {
        this.publish = true
      }
      if (!this.audienceName) {
        this.saveAudienceDialog = true

        return false
      }
      const { audienceType, audienceSubType } = this
      this.loading = true
      this.saveAudienceDraft().then(data => {
        if (
          publish &&
          !(
            audienceType === "targeting" ||
            !["lookalike", "template"].includes(audienceSubType)
          )
        ) {
          AudiencesAPI.publishAudienceDraft(data.id)
            .then(() => {
              this.$router.push("/audiences?success")
            })
            .catch(error => {
              this.loading = false
              this.$toast.error({
                component: Toastification,
                props: {
                  title: "Nelze nahrát publikum na Facebook",
                  text: error.data.exception.message,
                },
              })
            })
        } else {
          this.$router.push("/audiences?success")
        }
      })
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@audience`, {
        audienceName: "name",
        audienceType: "audienceType",
        audienceSubType: "audienceSubType",
      }),
      ...get(`${storeNamespace}/model@audience.targeting`, [
        "ageFrom",
        "ageTo",
        "genders",
        "excludedGeoLocations",
        "excludedInterests",
        "geoLocations",
        "geoLocationsTypes",
        "interestsGroups",
      ]),
    })

    Object.assign(this.$options.methods, {
      ...call(storeNamespace, ["saveAudienceDraft"]),
    })
  },
  mounted() {
    this.videoTutorial = "https://player.vimeo.com/video/693591455?h=3db4647f09"
  },
}
</script>
